module.exports = __webpack_public_path__ + "static/media/ftm.6e8ee825.png";